var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "chat-message",
        { staticClass: "mb-1", attrs: { type: "system" } },
        [
          _vm.response && !_vm.clickedStop
            ? _c(
                "div",
                [
                  _vm.isTyping
                    ? _c("text-typed", {
                        attrs: {
                          text: _vm.responseText,
                          stopped: _vm.clickedStop,
                        },
                        on: {
                          start: _vm.onServerTypingStart,
                          done: _vm.onServerTypingDone,
                        },
                      })
                    : _c("chat-question-response", {
                        attrs: { response: _vm.response },
                      }),
                ],
                1
              )
            : _vm.clickedStop
            ? _c("div", [
                _vm._v(
                  "\n            Response generation was stopped, try entering a new question.\n        "
                ),
              ])
            : _vm.error
            ? _c("div", { staticClass: "red--text" }, [
                _vm._v("\n            " + _vm._s(_vm.error) + "\n        "),
              ])
            : _vm.isWaitingServerResponse
            ? _c("text-typed", {
                attrs: {
                  text: _vm.randomThinkingText,
                  stopped: _vm.clickedStop,
                  speed: 5,
                },
              })
            : _vm._e(),
        ],
        1
      ),
      _vm._v(" "),
      _vm.isWaitingServerResponse || _vm.isTyping
        ? _c(
            "div",
            { staticClass: "server-message-stop" },
            [
              _c(
                "v-btn",
                {
                  attrs: { text: "", small: "" },
                  on: { click: _vm.stopGeneratingClicked },
                },
                [
                  _c("v-icon", { attrs: { left: "" } }, [_vm._v("mdi-close")]),
                  _vm._v("\n            Stop generating response\n        "),
                ],
                1
              ),
            ],
            1
          )
        : _vm.responseText && !_vm.clickedStop
        ? _c(
            "div",
            {
              staticClass: "server-message-rating text-sm d-flex align-center",
            },
            [
              _c("strong", [_vm._v("Rate this answer")]),
              _vm._v(" "),
              _c(
                "v-btn",
                {
                  attrs: { icon: "" },
                  on: {
                    click: function ($event) {
                      return _vm.rateAnswerClicked(true)
                    },
                  },
                },
                [
                  _c("v-icon", { attrs: { color: "primary" } }, [
                    _vm._v(
                      _vm._s(
                        _vm.userFeedback === 1
                          ? "mdi-thumb-up"
                          : "mdi-thumb-up-outline"
                      )
                    ),
                  ]),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "v-btn",
                {
                  attrs: { icon: "" },
                  on: {
                    click: function ($event) {
                      return _vm.rateAnswerClicked(false)
                    },
                  },
                },
                [
                  _c("v-icon", { attrs: { color: "primary" } }, [
                    _vm._v(
                      _vm._s(
                        _vm.userFeedback === -1
                          ? "mdi-thumb-down"
                          : "mdi-thumb-down-outline"
                      )
                    ),
                  ]),
                ],
                1
              ),
            ],
            1
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }